export type DashboardIndicators = {
  tareasPendientes: number;
};

export type DashboardIndicatorLoadingFlags = {
  loadingTareasResumen: boolean;
  loadingLeidoCounts: boolean;
  loadingResumen: boolean;
  loadingProcesosEstadosResumen: boolean;
  loadingBuzonIndicadores: boolean;
  canEmpresas: boolean;
  loadingSellosResumen: boolean;
  loadingFielResumen: boolean;
};

export function tareasPendientesDashboardMessage(n: number): string | null {
  if (!Number.isFinite(n) || n <= 0) return null;
  return `Tengo ${n} Tareas Pendientes en mi Dashboard`;
}

export function runDashboardPostInit(
  indicators: DashboardIndicators,
  addMessage?: (text: string) => void,
): void {
  const send = addMessage ?? (text => window.addMessageToChat?.(text));
  const message = tareasPendientesDashboardMessage(indicators.tareasPendientes);
  if (message) send(message);
}

export function bindWindowPostInit(
  getIndicators: () => DashboardIndicators,
  addMessage?: (text: string) => void,
  win: Window & { postInit?: () => void } = window,
): () => void {
  win.postInit = () => runDashboardPostInit(getIndicators(), addMessage);
  return () => {
    if (win.postInit) delete win.postInit;
  };
}

export function shouldRunDashboardPostInit(state: {
  loadStarted: boolean;
  alreadyRan: boolean;
  anyIndicatorLoading: boolean;
}): boolean {
  return state.loadStarted && !state.alreadyRan && !state.anyIndicatorLoading;
}

export function anyDashboardIndicatorLoading(flags: DashboardIndicatorLoadingFlags): boolean {
  return (
    flags.loadingTareasResumen ||
    flags.loadingLeidoCounts ||
    flags.loadingResumen ||
    flags.loadingProcesosEstadosResumen ||
    flags.loadingBuzonIndicadores ||
    (flags.canEmpresas && (flags.loadingSellosResumen || flags.loadingFielResumen))
  );
}
